export default __webpack_public_path__ + "static/media/William_Johnson_IMG3836.b762ada5.jpg";